import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import JournalComponent from 'components/journal/journal';
import { getAllCheckins, deleteCheckin } from '../../actions/checkin';

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getAllCheckins,
        deleteCheckin
    }, dispatch);
}

function mapStateToProps(state, ownProps) {
    return {
        checkins: _.filter(state.checkins, checkin => checkin != null && checkin.id == ownProps.params.id),
        currentUser: state.currentUser
    };
}

const JournalSingle = connect(
    mapStateToProps,
    mapDispatchToProps
)(JournalComponent);

export default JournalSingle;


// WEBPACK FOOTER //
// ./src/app/containers/journal/journalSingle.jsx